// eslint-disable-next-line import/prefer-default-export
export const INSTAGRAM_COLOR = 'linear-gradient(49.2deg,#f9ed32 10%,#ee2a7b 55%,#002aff)';

export function getInstagramConfig() {
  return {
    color: INSTAGRAM_COLOR,
  };
}
